var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleoff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 16,
    viewBox: "0 0 33 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.27002,
    width: 32,
    height: 16,
    rx: 8,
    fill: "#44546F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3933 4.93203L23.2706 7.05536L21.1466 4.93136C21.0831 4.86926 20.9977 4.83465 20.9089 4.83502C20.82 4.8354 20.7349 4.87072 20.6719 4.93336L20.2053 5.4007C20.1733 5.43134 20.1479 5.46809 20.1304 5.50876C20.1129 5.54943 20.1038 5.5932 20.1035 5.63747C20.1033 5.68173 20.1119 5.7256 20.1289 5.76647C20.146 5.80733 20.171 5.84436 20.2026 5.87536L22.3259 7.99803L20.2033 10.122C20.1413 10.1856 20.1068 10.2711 20.1073 10.3599C20.1078 10.4487 20.1432 10.5338 20.2059 10.5967L20.6726 11.0634C20.8099 11.2014 21.0166 11.1967 21.1473 11.066L23.2713 8.9427L25.3939 11.066C25.4575 11.128 25.543 11.1625 25.6318 11.162C25.7207 11.1615 25.8057 11.1261 25.8686 11.0634L26.3359 10.5967C26.3678 10.566 26.3933 10.5292 26.4107 10.4885C26.4281 10.4478 26.4372 10.4041 26.4374 10.3598C26.4376 10.3155 26.4288 10.2717 26.4118 10.2308C26.3947 10.19 26.3696 10.153 26.3379 10.122L24.2139 7.99803L26.3379 5.87536C26.4001 5.81186 26.4347 5.72645 26.4343 5.63762C26.4339 5.54879 26.3986 5.46368 26.3359 5.4007L25.8693 4.93403C25.838 4.90201 25.8007 4.87651 25.7595 4.859C25.7183 4.8415 25.674 4.83233 25.6293 4.83203C25.5854 4.83239 25.542 4.84141 25.5016 4.85857C25.4613 4.87573 25.4247 4.90069 25.3939 4.93203H25.3933Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.27002,
    cy: 8,
    r: 6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleoff);
export default __webpack_public_path__ + "static/media/toggleoff.f62b1bf62063c9ba0bded34b6dc8e960.svg";
export { ForwardRef as ReactComponent };